import { PACKAGE_STATUS_LABELS } from './package-raw-statuses';

export const IMPORTANT_STATUSES = new Set([
    'Started',
    'Completed',
    'Failed',
    'Stopped'
]);

/**
 * Универсальный нормализатор статусов.
 * @param {number|string} state - числовой WS код или строка HTTP
 * @returns {string|null} бизнес-статус
 */
export const resolvePackageState = (state) => {
    if (state == null) return null;

    // WS numeric
    if (typeof state === 'number') {
        return PACKAGE_STATUS_LABELS[state] ?? null;
    }

    // HTTP string
    if (typeof state === 'string') {
        return state;
    }

    return null;
};
